import { Footer } from "@/components/Footer";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Link } from "react-router-dom";

const TermsOfService = () => {
  return (
    <main className="min-h-screen">
      <ThemeToggle />
      <section className="py-8 px-4 border-b border-border">
        <div className="container mx-auto max-w-6xl">
          <Link to="/" className="text-sm text-muted-foreground hover:text-foreground transition-colors">← Back to Home</Link>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="container mx-auto max-w-4xl prose prose-neutral dark:prose-invert">
          <h1 className="font-heading text-4xl font-bold mb-8 text-foreground">Terms of Service</h1>
          <p className="text-sm text-muted-foreground mb-8">Last updated: March 11, 2026</p>

          <div className="space-y-8 text-muted-foreground">
            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">1. Acceptance of Terms</h2>
              <p>By accessing or using the Healion.ai website and services ("Services"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our Services.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">2. Description of Services</h2>
              <p>Healion.ai provides an AI-powered automated bug fixing platform that integrates with error monitoring tools (such as Sentry, Datadog, New Relic, and Zipy) to detect, analyze, and generate code fixes for production errors. Our Services include:</p>
              <ul className="list-disc list-inside space-y-2 mt-2">
                <li>Automated error detection and analysis via webhooks</li>
                <li>AI-powered root cause analysis and code fix generation</li>
                <li>Automated pull request creation on supported platforms (GitHub, GitLab, Bitbucket)</li>
                <li>Integration with third-party monitoring and development tools</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">3. User Accounts</h2>
              <p>To use certain features, you may need to create an account. You are responsible for:</p>
              <ul className="list-disc list-inside space-y-2 mt-2">
                <li>Maintaining the confidentiality of your account credentials</li>
                <li>All activities that occur under your account</li>
                <li>Providing accurate and complete information</li>
                <li>Notifying us immediately of any unauthorized access</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">4. Acceptable Use</h2>
              <p>You agree not to:</p>
              <ul className="list-disc list-inside space-y-2 mt-2">
                <li>Use the Services for any unlawful purpose</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Interfere with or disrupt the Services</li>
                <li>Reverse engineer, decompile, or disassemble any part of the Services</li>
                <li>Use the Services to transmit malicious code or harmful content</li>
                <li>Resell or redistribute the Services without authorization</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">5. Intellectual Property</h2>
              <p>All content, features, and functionality of the Services are owned by Healion.ai and are protected by intellectual property laws. You retain ownership of your code and data. By using our Services, you grant us a limited license to access your code repositories solely for the purpose of providing bug fixes.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">6. Payment & Billing</h2>
              <p>Certain features may require payment. By subscribing to a paid plan, you agree to pay the applicable fees. All fees are non-refundable unless otherwise stated. We reserve the right to change our pricing with reasonable notice.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">7. Service Availability</h2>
              <p>We strive to maintain high availability but do not guarantee uninterrupted access. We may perform maintenance, updates, or modifications that temporarily affect service availability. We are not liable for any downtime or service interruptions.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">8. Limitation of Liability</h2>
              <p>To the maximum extent permitted by law, Healion.ai shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, or business opportunities. Our total liability shall not exceed the amount paid by you in the 12 months preceding the claim.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">9. Disclaimer of Warranties</h2>
              <p>The Services are provided "as is" and "as available" without warranties of any kind. We do not guarantee that AI-generated code fixes will be error-free, complete, or suitable for your specific use case. You are responsible for reviewing and testing all generated code before deployment.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">10. Termination</h2>
              <p>We may suspend or terminate your access to the Services at any time for violation of these Terms or for any other reason at our discretion. Upon termination, your right to use the Services will immediately cease.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">11. Governing Law</h2>
              <p>These Terms shall be governed by and construed in accordance with applicable laws, without regard to conflict of law principles.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">12. Changes to Terms</h2>
              <p>We reserve the right to modify these Terms at any time. We will provide notice of material changes by updating the "Last updated" date. Continued use of the Services after changes constitutes acceptance of the modified Terms.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">13. Contact Us</h2>
              <p>If you have questions about these Terms, please contact us at:</p>
              <p className="mt-2 font-medium text-foreground">legal@healion.ai</p>
            </section>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default TermsOfService;
